import {
  Organization,
  OrganizationList,
  ParsedOrganization,
  ParsedOrganizationList,
} from './types';

const parse = (item: Organization): Readonly<ParsedOrganization> =>
  Object.freeze({
    id: item.id || null,
    code: item.code || '',
    text: item.text || '',
    name: item.name || '',
    img: item.logo || '',
    link: {
      name: 'organization',
      params: { code: item.code || '', id: String(item.id) },
    },
    title: item.name || '',
  });

const parseOrganizationList = (
  data: OrganizationList,
): ParsedOrganizationList => data.map(parse);

export default parseOrganizationList;



// WEBPACK FOOTER //
// ./src/services/api/organizations/utils/parseOrganizationList.ts